<div class="container-flex">
  <div class="tabla-container">
    <app-tabla
      [totalCount]="totalCount"
      [datos]="logHttp"
      [columnas]="columnas"
      [name]="name"
      [pageSizeOptions]="helper.pageSizeOptions"
      [search]="search"
      [(query)]="query"
      (queryChange)="listar()"
      [paginatorArriba]="false"
      [filtros]="filtros"
      [emptyState]="{ title: 'Todavía no hay logs de prueba' }"
    ></app-tabla>
  </div>

  @if (logGenericoSeleccionado) {
    <div class="detalles-container">
      <app-detalles-log-generico
        [title]="'Detalles Log Genérico - ID: ' + logGenericoSeleccionado._id"
        [data]="logGenericoSeleccionado"
        (close)="cerrarDetalles()"
      ></app-detalles-log-generico>
    </div>
  }
</div>
